//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import {queryProjectTypeCodeNumber,queryProjectStatusNumber,queryProjectGroupByDeptCode,queryProjectParams} from '@/api/pm/project';

	export default {
		data() {
			return {
				allProjectOverview: [], //所有的项目类型数量总览
				projectStatusOverview:[], //所有项目的状态及其数量预览
				projectGroupByDeptCode:[], //不同部门项目数量及其项目类型
				queryParams:{
					projTypeCode: '',
					status: '',
					respDeptCode: '',
				},
			}
		},
		created() {

		},
		computed: {},
		mounted: function() {
			this.loadProjectTypeCodeNumber('');
			this.loadQueryProjectStatusNumber();
			this.loadProjectGroupByDeptCode('');
		},
		methods: {
			// 返回
			goback() {
				// 返回工作台
				this.$router.push({
					name: 'workbench'
				});
			},
			// 筛选
//			filter() {
//				this.filterOpen = !this.filterOpen;
//			},
			//根据条件获取每种项目类型的项目数量
			loadProjectTypeCodeNumber(value){
				var condition = {'respDeptCode':value};
		        queryProjectTypeCodeNumber(condition).then(response => {
		        	// 数据赋值
	          		for(let i = 0 ; i < response.length ; i++){
	          			this.allProjectOverview.push(response[i]);
	          		}
		        });
		    },
			//家庭每种项目状态及其数量
			loadQueryProjectStatusNumber(){
		        queryProjectStatusNumber().then(response => {
		        	// 数据赋值
	          		for(let i = 0 ; i < response.length ; i++){
	          			this.projectStatusOverview.push(response[i]);
	          		}
		        });
			},
			//不同部门的项目数量
			loadProjectGroupByDeptCode(value){
				var condition = {'respDeptCode':value};
		        queryProjectGroupByDeptCode(condition).then(response => {
		        	//数据赋值
	          		for(let i = 0 ; i < response.length ; i++){
	          			this.projectGroupByDeptCode.push(response[i]);
	          		}
		        });
			},
			//进入列表信息
			loadListData(projTypeCode,status,respDeptCode){
				// 赋值
				this.queryParams.projTypeCode = projTypeCode;
				this.queryParams.status = status;
				this.queryParams.respDeptCode = respDeptCode;
				var condition = {
					'condition': JSON.stringify(this.queryParams)
				};
				queryProjectParams(condition).then(response => {
					// 刷新情况下
					var length = response.length;
					var jsonarray = [];
					for(let i = 0 ; i<response.length ; i++){
						jsonarray.push(response[i].id);
					}
//					var ids =  jsonarray.join(",");
					if(projTypeCode == '005'){
						// 预算售前人员
						this.$router.push({
							name: '预算售前人员',
							params: {
								gobackName: '项目预算总览',
								projTypeCode:projTypeCode,
								ids: jsonarray,
							}
						});
					}else{
						this.$router.push({
							name: '项目预算列表',
							params: {
								gobackName: '项目预算总览',
								ids: jsonarray,
							}
						});
					}
				});
				
			}
		}
	}



// WEBPACK FOOTER //
// ./src/view/pm/budget/budgetOverview.vue